/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPNOTAXNUMBERREASON = {
    TheCountryWhereYouAreLiableToPayTaxDoesNotIssueTaxNumbersToItsTaxResidents: 'C',
    NoTaxNumberIsRequiredByMyTaxAuthority: 'I',
    YouAreUnableToObtainATaxNumberPleaseSpecify: 'N'
} as const;
export type IAPNOTAXNUMBERREASON = typeof IAPNOTAXNUMBERREASON[keyof typeof IAPNOTAXNUMBERREASON];


export function IAPNOTAXNUMBERREASONFromJSON(json: any): IAPNOTAXNUMBERREASON {
    return IAPNOTAXNUMBERREASONFromJSONTyped(json, false);
}

export function IAPNOTAXNUMBERREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPNOTAXNUMBERREASON {
    return json as IAPNOTAXNUMBERREASON;
}

export function IAPNOTAXNUMBERREASONToJSON(value?: IAPNOTAXNUMBERREASON | null): any {
    return value as any;
}

